var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accept-terms"},[_c('div',{staticClass:"accept-terms__content"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"accept-terms__logo img-fluid",attrs:{"src":require("@/assets/images/logos/accounts-logo.svg"),"alt":"Tendencys"}})]),_c('accept-terms-form')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }